import { ButtonBack } from "components/buttons";
import { MprcContainer } from "components/MprcContainer";
import { MprcFormBarHeader } from "components/MprcFormBarHeader";
import { MprcPrompt } from "components/MprcPrompt";
import { useCallbackPrompt } from "hooks/useCallbackPrompt";
import React, { useState } from "react";
import { useLocation } from "react-router";
import { RootPaths } from "routes/RootRouter";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    actions?: React.ReactNode[];
    recordChanged: boolean;
    reloadOnClose: boolean;
    onClose: (reload?: boolean) => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Edição de Papéis de Segurança
 * @param props
 */
export const EditUserHeader: React.FC<IProps> = (props) => {
    ////////////////////////////////////////////////////////////////////////////
    const location = useLocation();
    const { actions, recordChanged, reloadOnClose, onClose } = props;
    const [showLostChange, setShowLostChange] = useState<boolean>(false);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(props.recordChanged);

    ////////////////////////////////////////////////////////////////////////////

    const handleClose = () => {
        if (recordChanged) {
            setShowLostChange(true);
        }
        else {
            onClose(reloadOnClose);
        }
    };

    var headerItems: React.ReactNode[] = [];

    headerItems.push(
        location.pathname != RootPaths.EditSelfProfile
            ? <ButtonBack rounded size="large" variant="text" onClick={handleClose} />
            : <span>&nbsp;</span>
    );

    if (actions)
        headerItems = [...headerItems, ...actions];

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////


    return (
        <MprcContainer>
            <MprcFormBarHeader actions={headerItems} />

            <MprcPrompt
                open={showPrompt}
                onConfirm={confirmNavigation}
                onCancel={cancelNavigation} />

            <MprcPrompt
                open={showLostChange}
                onCancel={() => setShowLostChange(false)}
                onConfirm={onClose} />

        </MprcContainer>
    );
};
